// Ancho de trabajo del shell: abajo de este corte el sidebar completo se come la pantalla, así que
// arranca como riel de íconos. Es el `md` de Tailwind, el mismo que usa el resto del repo.
import { useSyncExternalStore } from 'react';

export const COMPACT_VIEWPORT_QUERY = '(max-width: 767px)';

function subscribe(onChange: () => void): () => void {
    const list = window.matchMedia(COMPACT_VIEWPORT_QUERY);
    list.addEventListener('change', onChange);
    return () => {
        list.removeEventListener('change', onChange);
    };
}

/** Si la ventana está abajo del corte compacto. Se re-evalúa al cambiar el ancho. */
export function useCompactViewport(): boolean {
    return useSyncExternalStore(
        subscribe,
        () => window.matchMedia(COMPACT_VIEWPORT_QUERY).matches,
        () => false,
    );
}
